import React from "react";
import { withRouter } from "react-router-dom";
import { Typography } from "../../ecosystem/";
import ECheckInCTA from "../appointment/ECheckInCTA";
import { DashboardTile } from "../DashboardTile";
import { formatDoctorName, getFirstName } from "../../../helpers/formatting";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import AppointmentPricing from "./appointmentPricing";
import AppointmentTileHeading from "../appointment/appointmentTileHeading";

export function AppointmentInPersonTile(props) {
    const { appointmentDetails, isMobile = false, isRequireEcheckin, getAddressMarkup, getPhoneNumberMarkup, visit } = props;

    const eCheckInAvailable = appointmentDetails && appointmentDetails.eCheckInStatus && appointmentDetails.eCheckInStatus.toLowerCase() !== "not yet available" ? true : false;
    const eCheckinCompleted = (appointmentDetails && appointmentDetails.eCheckInStatus) ? appointmentDetails.eCheckInStatus.toLowerCase() === "completed" : false;

    const apptCSNEncrypted = appointmentDetails && appointmentDetails.csnIdOfAppointmentEncrypted ? appointmentDetails.csnIdOfAppointmentEncrypted : '';

    const patientExternalId = appointmentDetails && appointmentDetails.patientExternalId ? appointmentDetails.patientExternalId : ''; 

    const patientName = appointmentDetails && appointmentDetails.patientName ? getFirstName(appointmentDetails.patientName) : '';

    const appointmentArrivalTime = appointmentDetails && appointmentDetails.appointmentArrivalTime ? appointmentDetails.appointmentArrivalTime : ''; 

    const heading =
        <AppointmentTileHeading
            patientName={patientName}
            visitName={appointmentDetails?.appointmentType}
            to={{ pathname: "/visit/details", state: { csnId: apptCSNEncrypted, Id: patientExternalId } }}
        />;

    const apptTimeToShow = appointmentArrivalTime ? 'Arrive by ' + appointmentArrivalTime : appointmentDetails?.appointmenttimes;

    return (
        <DashboardTile
            className="appt-refresh-tile"
            heading={heading}
        >
            <React.Fragment>
                <div className="col-12 appt-tile-body--in-person">
                    <div className="row">
                        <div className="col-12 col-xl appt-tile-body__info">
                            <div className="appt-tile-body__time">
                                <Typography type="heading-02" >
                                    {(appointmentDetails.appointmentEcheckinDays === 0 || appointmentDetails.appointmentEcheckinDays === 1)
                                        ? (<>{appointmentDetails.appointmentEcheckinDays === 0
                                            ? <span>{`Today, ${apptTimeToShow}`}</span>
                                            : <span>{`Tomorrow, ${apptTimeToShow}`}</span>
                                        }
                                        </>)
                                        : `${appointmentDetails?.appointmentDateTimeForDisplay}, ${apptTimeToShow}`}
                                </Typography>
                                {appointmentArrivalTime &&
                                    <Typography
                                        type="body-02"
                                        tag="div"
                                        color="$color-secondary-a2"
                                    >
                                        {`Starts at ${appointmentDetails?.appointmenttimes}`}
                                    </Typography>}
                            </div>
                            <AppointmentPricing visit={visit} />
                            <div className="appt-tile-body__address">
                                {getAddressMarkup()}
                            </div>
                            {appointmentDetails && appointmentDetails?.physicianName && 
                                <div className="appt-tile-body__doc">
                                    <Typography type="heading-02" tag="div">
                                        {formatDoctorName(appointmentDetails?.physicianName)}
                                    </Typography>
                                </div>
                            }
                            <div className="appt-tile-body__phone">
                                {getPhoneNumberMarkup()}
                            </div>
                        </div>
                        {eCheckInAvailable && 
                            <div className="col-12 col-xl appt-tile-body__echeckin">
                                <ECheckInCTA
                                    appointmentDetails={appointmentDetails}
                                    eCheckInStatus={appointmentDetails.eCheckInStatus}
                                    eCheckinCompleted={eCheckinCompleted}
                                    isRequireEcheckin={isRequireEcheckin}
                                    csnIdOfAppointment={appointmentDetails.csnIdOfAppointmentEncrypted}
                                    isMobile={isMobile}
                                />
                            </div>
                        }
                    </div>
                </div>
            </React.Fragment>
        </DashboardTile>
    );
}

export default withRouter(AppointmentInPersonTile);


